import {PluginListenerHandle} from '@capacitor/core';
import {ConnectionStatus, Network} from '@capacitor/network';
import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NetworkDetector implements OnDestroy {

    public networkStatusSubject$ = new BehaviorSubject<ConnectionStatus>(null);

    private connectionStatus: ConnectionStatus;
    private networkListener: PluginListenerHandle;

    constructor() {
        void this.setupListener().then();
    }

    async setupListener() {
        this.networkListener = await Network.addListener('networkStatusChange', (status) => {
            this.connectionStatus = status;
            this.networkStatusSubject$.next(status);
        });
        this.connectionStatus = await Network.getStatus();
        this.networkStatusSubject$.next(this.connectionStatus);
    }

    ngOnDestroy() {
        void this.networkListener.remove().then();
    }

    /**
     * Until Capacitor's async Network.getStatus() resolves, falls back to navigator.onLine
     * rather than returning undefined. Every "are we offline?" check in the app reads
     * getStatus()?.connected === false, so an undefined status during startup read as
     * "online" - confirmed live: opening the app offline fired the startup Person lookup
     * before this had resolved, and its 504 hard-navigated to /error/504 despite the offline
     * error suppression in CatchitHttpService/CatchitErrorHandlerService.
     */
    getStatus(): ConnectionStatus {
        return this.connectionStatus ?? {
            connected: navigator.onLine,
            connectionType: navigator.onLine ? 'unknown' : 'none'
        };
    }
}
